import React, { useState, useEffect } from "react";
import firebase from "../firebase";
import { Button, Form, FormGroup, Input, Progress } from "reactstrap";
// import SplitPane from "react-split-pane";
import ReactMarkdown from "react-markdown";
import Prism from "prismjs";
import "prismjs/themes/prism.css";
import "prismjs/themes/prism-solarizedlight.css";
import { validate, placeholders, errorStrings } from "../helpers/validation";
import { Bar } from "./loader";
import Header2 from "./header2";
import Editor from "./editor";
import "./create-course.css";

let editorRef = "";

const didLoad = () => {
  console.log("Editor loaded");
};

const didMount = editor => {
  editorRef = editor;
};

const CreateCourse = props => {
  const db = firebase.firestore();
  const storage = firebase.storage();

  const initialState = {
    course: {
      value: props.location.state.courses[0].courseID || "",
      valid: true,
      validationRules: {
        isString: true
      },
      error: ""
    },
    courseID: {
      value: "",
      valid: true,
      validationRules: {
        isSting: true
      },
      error: ""
    },
    lesson: {
      value: "",
      valid: true,
      validationRules: {
        isSting: true
      },
      error: ""
    },
    module: {
      value: "",
      valid: true,
      validationRules: {
        isSting: true
      },
      error: ""
    },
    title: {
      value: "",
      valid: true,
      validationRules: {
        isSting: true
      },
      error: ""
    },
    content: {
      value: "",
      valid: true,
      validationRules: {
        isSting: true
      },
      error: ""
    }
  };
  const [formState, setFormState] = useState(initialState);
  const [lang, setLanguage] = useState("markdown");
  const [theme, setTheme] = useState("vs-light");
  const [markdownCode, setMarkdownCode] = useState("");
  //const [content, setContent] = useState();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    Prism.highlightAll();
  });

  // not needed now; fetch content later when doing CRUD operations
  // useEffect(() => {
  //   setLoading(true);

  //   const fetchContent = () => {
  //     const contentRef = db
  //       .collection("content")
  //       .where("courseID", "==", formState.course.value)
  //       .orderBy("lesson");
  //     contentRef.onSnapshot(data => {
  //       setContent(data);

  //       const courseLength = data.docs.length || 0;
  //       console.log("create-course array length: ", courseLength);

  //       setLoading(false);
  //     });
  //   };
  //   formState["course"] && fetchContent();
  // }, [formState["course"]]);

  const handleValueChange = code => {
    setMarkdownCode(code);
    formState.content.value = code;
  };

  const handleChange = (key, event) => {
    event.preventDefault();

    let ctrl = { ...formState[key] };
    ctrl.value = event.target.value;
    const isValid = validate(
      event.target.value,
      formState[key].validationRules
    );
    ctrl.valid = isValid;
    let error = "";
    if (!isValid && ctrl.value !== "") {
      error = errorStrings[key];
    } else error = "";
    ctrl.error = error;

    setFormState({ ...formState, [key]: ctrl });
  };

  const handleAddContent = () => {
    const storageRef = storage.ref();
    const contentRef = storageRef.child(
      `md/${formState.course.value}-${formState.lesson.value}.md`
    );

    const uploadTask = contentRef.putString(formState.content.value);
    uploadTask.on(
      "state_changed",
      snapshot => {
        // progress function ....
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      error => {
        // error function ....
        console.log("create-course -> upload error: ", error);
      },
      () => {
        // complete function ....
        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          db.collection("content")
            .add({
              courseID: formState.course.value, //same as course value
              filename: downloadURL,
              lesson: formState.lesson.value,
              module: formState.module.value,
              title: formState.title.value,
              content: "",
              timestamp: firebase.firestore.FieldValue.serverTimestamp()
            })
            .then(docRef => {
              //console.log("Document written with ID: ", docRef.id);
              setFormState(initialState);
              setProgress(0);
              setMarkdownCode("");
            })
            .catch(error => {
              console.error("create-course -> Error adding document: ", error);
            });
        });
      }
    );
  };

  const courseOptions = props.location.state.courses.map(course => (
    <option key={course.id} value={course.courseID}>
      {course.courseName}
    </option>
  ));

  const actions = (
    <div>
      <Form className="form-body">
        <FormGroup>
          <h5>Create Course</h5>
        </FormGroup>
        <FormGroup>
          <Input
            className="form-control input-text text-start"
            style={{ backgroundColor: "#fff" }}
            value={formState.course.value || ""}
            onChange={event => handleChange("course", event)}
            type="select"
            placeholder="Select course"
          >
            {courseOptions}
          </Input>
        </FormGroup>
        <FormGroup>
          <Input
            className="disabled input-text text-start"
            style={{ backgroundColor: "#fff" }}
            value={formState.course.value || "Course ID"}
            onChange={event => handleChange("module", event)}
            type="text"
            placeholder={placeholders["courseID"]}
          />
        </FormGroup>
        <FormGroup>
          <Input
            className="text-start"
            style={{ backgroundColor: "#fff" }}
            value={formState.lesson.value || ""}
            onChange={event => handleChange("lesson", event)}
            type="text"
            placeholder={placeholders["lesson"]}
          />
        </FormGroup>
        <FormGroup>
          <Input
            className="input-text text-start"
            style={{ backgroundColor: "#fff" }}
            value={formState.module.value || ""}
            onChange={event => handleChange("module", event)}
            type="text"
            placeholder={placeholders["module"]}
          />
        </FormGroup>
        <FormGroup>
          <Input
            className="text-start"
            style={{ backgroundColor: "#fff" }}
            value={formState.title.value || ""}
            onChange={event => handleChange("title", event)}
            type="text"
            placeholder={placeholders["title"]}
          />
        </FormGroup>
        <FormGroup>
          <Input
            className="text-start text-truncate"
            style={{ backgroundColor: "#fff" }}
            value={formState.content.value || ""}
            onChange={event => handleChange("content", event)}
            type="text"
            placeholder={placeholders["content"]}
          />
        </FormGroup>
        <FormGroup>
          <Button color="success" onClick={handleAddContent}>
            Add Content
          </Button>
        </FormGroup>
        <Progress color="success" value={progress}>
          {progress} {"%"}
        </Progress>
      </Form>
    </div>
  );

  return (
    <div className="cc-container contaner-fluid">
      <Header2 />

      <div className="cc-action-editor-preview-container">
        <div className="cc-action-container">
          <Bar loading={loading} />
          {actions}
        </div>
        <div className="cc-editor-container">
          <Editor
            didLoad={didLoad}
            didMount={didMount}
            value={markdownCode}
            selectedLanguage={lang}
            selectedTheme={theme}
            onValueChange={handleValueChange}
          />
        </div>
        <div className="cc-preview-container">
          <ReactMarkdown
            style={{ whiteSpace: "pre-wrap" }}
            source={markdownCode}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateCourse;
